export const DELETE_SERVICE_RATE = '@@toyota/DELETE_SERVICE_RATE';
export const DOWNLOADING_SERVICE_RATE_FILE = '@@toyota/DOWNLOADING_SERVICE_RATE_FILE';
export const DOWNLOADED_SERVICE_RATE_FILE = '@@toyota/DOWNLOADED_SERVICE_RATE_FILE';
export const DOWNLOADED_SERVICE_RATE_FILE_FAILED = '@@toyota/DOWNLOADED_SERVICE_RATE_FILE_FAILED';
export const DELETE_URL_SERVICE_RATE = '@@toyota/DELETE_URL_SERVICE_RATE';
export const FETCHING_SERVICE_RATE = '@@toyota/FETCHING_SERVICE_RATE';
export const FETCHED_SERVICE_RATE = '@@toyota/FETCHED_SERVICE_RATE';
export const FETCHED_SERVICE_RATE_FAILED = '@@toyota/FETCHED_SERVICE_RATE_FAILED';
export const FETCHING_ICC = '@@toyota/FETCHING_ICC';
export const FETCHED_ICC = '@@toyota/FETCHED_ICC';
export const FETCHED_ICC_FAILED = '@@toyota/FETCHED_ICC_FAILED';
